import React from 'react';

function Support() {
  return <div>

    By supporting us, you can ensure that we continue to improve and enhance the platform.
    Features wont change if you support us or not. 
    

  </div>;
}

export default Support;
